<template>
  <div class="archives">
    <h1 class="maintitle">Archives</h1>

    <div class="game" v-for="(score, index) in games" :key="index">
      <div>
        <router-link
          tag="button"
          class="gameTitle underline"
          :to="{ name: 'score', params: { id: score.id } }"
          >{{ score.settings.name }}
        </router-link>

      </div>

      <div class="">
        <div class="flex-col text-right">
          <div v-if="score.players.length">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              class="svg size-6 text-gray-500 hidden"
            >
              <path
                d="M7 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1c2.15 0 4.2.4 6.1 1.09L12 16h-1.25L10 20H4l-.75-4H2L.9 10.09A17.93 17.93 0 0 1 7 9zm8.31.17c1.32.18 2.59.48 3.8.92L18 16h-1.25L16 20h-3.96l.37-2h1.25l1.65-8.83zM13 0a4 4 0 1 1-1.33 7.76 5.96 5.96 0 0 0 0-7.52C12.1.1 12.53 0 13 0z"
              />
            </svg>
            <span
              class="tag-player item-tag"
              :class="'color-' + player.color "
              v-for="(player, index) in score.players"
              :key="index"
            >
              <span>
                {{ player.name }}
              </span>
              <span class="font-bold ml-1" v-if="player.total">
                {{ player.total }}
              </span>
            </span>
          </div>
          <div v-if="score.startTime" class="mr-2  text-gray-600 ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              class="svg size-4 "
            >
              <path
                d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
              />
            </svg>
            {{ score.endTime | humanizeDate }}
          </div>

          <ClassicButton
            v-if="!score.players.length "
            classButton="text-sm trashButton"
            flexOption=""
            @buttonClick="
              removeScore(index);
              showModal = false;
            "
          >
            <template v-slot:ButtonContent>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                class="fill-current h-8 w-8    block "
              >
                <path
                  d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z"
                ></path>
              </svg>
            </template>
          </ClassicButton>
        </div>
      </div>
      
      </div>
    </div>

</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "archives",
  data() {
    return {
      showModal: false,
      list_settings: [],
      list_scores: [],
      last_id: ""
    };
  },
  components: {
    
  },
  computed: {
    games() {
      return this.list_scores.filter(function(item) {
        return item.endTime;
      });
    }
  },
  methods: {
    removeScore(index) {
      this.list_scores.splice(index, 1);
    }
  },

  mounted() {
    if (localStorage.getItem("skor_list_scores")) {
      this.list_scores = JSON.parse(localStorage.getItem("skor_list_scores"));
    }
  },
  watch: {
    list_scores: {
      handler() {
        localStorage.setItem(
          "skor_list_scores",
          JSON.stringify(this.list_scores)
        );
      },
      deep: true
    }
  }
};
</script>
